__turbopack_context__.v({
  "cats": "style-module-scss-module__YCPTuq__cats",
  "item": "style-module-scss-module__YCPTuq__item",
  "label": "style-module-scss-module__YCPTuq__label",
  "title": "style-module-scss-module__YCPTuq__title",
});
